import {
  apiGet,
  apiSend,
  type BulkResult,
  type DeleteResult,
  type SavedVoucher,
  type VoucherDetail,
  type VoucherListRow,
} from './api.js';
import { auth } from './actor.js';
import type { VoucherTypeCode } from './voucher-config.js';
import type { VoucherPayload } from './voucher-model.js';




export async function peekVoucherNumber(type: VoucherTypeCode): Promise<string> {
  const { number } = await apiGet<{ type: string; number: string }>('/next-number', { type });
  return number;
}


export type SaveStatus = 'DRAFT' | 'PENDING_APPROVAL' | 'POSTED';

export function saveVoucher(payload: VoucherPayload, status: SaveStatus): Promise<SavedVoucher> {
  return apiSend<SavedVoucher>('POST', '/vouchers', payload, auth({ status }));
}

export function deleteVoucher(
  type: VoucherTypeCode,
  voucherNo: string,
  reason?: string,
): Promise<DeleteResult> {
  return apiSend<DeleteResult>(
    'DELETE',
    `/vouchers/${type}/${encodeURIComponent(voucherNo)}`,
    undefined,
    auth({ reason }),
  );
}

export function saveVoucherBatch(
  vouchers: VoucherPayload[],
  status: SaveStatus,
): Promise<BulkResult> {
  return apiSend<BulkResult>('POST', '/vouchers/bulk', { vouchers }, auth({ status }));
}


export async function listVouchers(type: VoucherTypeCode): Promise<VoucherListRow[]> {
  const { vouchers } = await apiGet<{ type: string; vouchers: VoucherListRow[] }>('/vouchers', {
    type,
  });
  return vouchers;
}

export function loadVoucher(type: VoucherTypeCode, voucherNo: string): Promise<VoucherDetail> {
  return apiGet<VoucherDetail>(`/vouchers/${type}/${encodeURIComponent(voucherNo)}`);
}
